<template>
  <div class="doubles-tab">
    <Subpanel
      :name="tabs.length"
      v-if="tabs.length"
      :tabs="tabs"
      module="doubles"
      class="doubles-tab__subpanel"
    />
  </div>
</template>

<script>
export default {
  components: { Subpanel: () => import('Elements/Subpanel/Subpanel') },
  props: {
    tabs: {
      type: Array,
      default: () => {
        return [];
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.doubles-tab {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;

  &__subpanel {
    min-height: 100%;
    & ::v-deep .tabs {
      min-height: 100%;
    }
  }
}
</style>
